(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var fmt = function (cents) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: .12 });
    $$('.rv').forEach(function (el) { io.observe(el); });
  } else { $$('.rv').forEach(function (el) { el.classList.add('in'); }); }

  /* Mobile nav */
  var mnav = $('#mnav');
  $$('[data-mnav]').forEach(function (b) {
    b.addEventListener('click', function () { if (mnav) mnav.classList.toggle('is-open'); });
  });
  if (mnav) $$('a', mnav).forEach(function (a) { a.addEventListener('click', function () { mnav.classList.remove('is-open'); }); });

  /* Cart drawer */
  var drawer = $('#cart-drawer');
  var body = $('#cart-body'), foot = $('#cart-foot'), countEls = $$('[data-cart-count]');

  function setCount(n) {
    countEls.forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function openCart() { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
  function closeCart() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); refresh().then(openCart); } }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); if (mnav) mnav.classList.remove('is-open'); } });

  function render(cart) {
    setCount(cart.item_count);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><p>Votre panier est vide.</p><a class="btn" href="/collections/all">Découvrir les masques</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '" loading="lazy" width="80" height="100">' : '<div></div>';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="ci__v">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="ci">' + img + '<div><a class="ci__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="qty"><button type="button" data-q="' + (i + 1) + '" data-d="' + (it.quantity - 1) + '" aria-label="Moins">–</button><span>' + it.quantity +
        '</span><button type="button" data-q="' + (i + 1) + '" data-d="' + (it.quantity + 1) + '" aria-label="Plus">+</button></div>' +
        '<button type="button" class="ci__rm" data-q="' + (i + 1) + '" data-d="0">Retirer</button></div>' +
        '<div>' + fmt(it.final_line_price) + '</div></div>';
    }).join('');
    if (foot) {
      foot.hidden = false;
      $('#cart-total', foot).textContent = fmt(cart.total_price);
    }
  }
  function refresh() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }
  if (body) body.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]'); if (!b) return;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.dataset.q, quantity: +b.dataset.d }) })
      .then(function (r) { return r.json(); }).then(render);
  });
  refresh();

  /* Add to cart (formulaires produit) */
  $$('form[data-ajax-atc]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[type=submit]', form); var old = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { openCart(); })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = old; } });
    });
  });

  /* Variantes */
  var pdp = $('[data-pdp]');
  if (pdp) {
    var variants = JSON.parse($('[data-variants]', pdp).textContent);
    var idInput = $('[name=id]', pdp), priceEl = $('[data-price]', pdp), atc = $('[data-atc]', pdp), sticky = $('#sticky-atc');
    var stickyPrice = $('[data-sticky-price]');
    var pick = function () {
      var sel = $$('.opt', pdp).map(function (o) { var c = $('input:checked', o); return c ? c.value : null; });
      var v = variants.filter(function (x) { return sel.every(function (s, i) { return s === null || x.options[i] === s; }); })[0];
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = fmt(v.price) + (v.compare_at_price > v.price ? '<s>' + fmt(v.compare_at_price) + '</s>' : '');
      if (stickyPrice) stickyPrice.textContent = fmt(v.price);
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Ajouter au panier' : 'Épuisé'; }
      if (v.featured_media_src) { var m = $('[data-gal-main] img'); if (m) m.src = v.featured_media_src; }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };
    $$('.opt input', pdp).forEach(function (i) { i.addEventListener('change', pick); });
    /* Galerie */
    $$('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var m = $('[data-gal-main] img'); if (m) { m.src = t.dataset.thumb; m.srcset = ''; m.alt = t.dataset.alt || ''; }
        $$('[data-thumb]').forEach(function (x) { x.classList.remove('is-on'); }); t.classList.add('is-on');
      });
    });
    /* Barre collante */
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { sticky.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(atc);
      var sb = $('button', sticky); if (sb) sb.addEventListener('click', function () { atc.click(); });
    }
  }

  /* Comparateur avant/après */
  $$('[data-cmp]').forEach(function (c) {
    var r = $('input', c), a = $('.cmp__after', c), bar = $('.cmp__bar', c), k = $('.cmp__knob', c);
    var set = function () { var v = r.value; if (a) a.style.clipPath = 'inset(0 0 0 ' + v + '%)'; bar.style.left = v + '%'; k.style.left = v + '%'; };
    r.addEventListener('input', set); set();
  });

  /* Header : se masque en descendant */
  var hdr = $('.hdr'), last = 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY; if (hdr) hdr.style.transform = (y > last && y > 240) ? 'translateY(-100%)' : 'none'; last = y;
  }, { passive: true });
})();
